import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit", "progress", "progressBar", "message", "result", "downloadLink", "errors"]
  static values = {
    startUrl: String,
    statusUrl: String,
    downloadUrl: String,
    initialJobId: String
  }

  connect() {
    this.pollTimer = null
    if (this.hasInitialJobIdValue && this.initialJobIdValue) {
      this.jobId = this.initialJobIdValue
      this.reset()
      this.submitTarget.disabled = true
      this.poll()
      this.pollTimer = window.setInterval(() => this.poll(), 1500)
    }
  }

  disconnect() {
    this.stopPolling()
  }

  async start(event) {
    event.preventDefault()
    this.reset()
    this.submitTarget.disabled = true

    const response = await fetch(this.startUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: new FormData(event.target)
    })

    if (!response.ok) {
      this.fail("Impossibile avviare l'elaborazione")
      return
    }

    const data = await response.json()
    this.jobId = data.job_id
    this.updateLocation()
    this.poll()
    this.pollTimer = window.setInterval(() => this.poll(), 1500)
  }

  async poll() {
    const response = await fetch(this.url(this.statusUrlValue), { headers: { "Accept": "application/json" } })
    if (!response.ok) {
      this.fail("Impossibile leggere lo stato dell'elaborazione")
      return
    }

    this.renderStatus(await response.json())
  }

  renderStatus(status) {
    const total = status.total || 1
    const progress = status.progress || 0

    this.progressBarTarget.max = total
    this.progressBarTarget.value = progress
    this.messageTarget.textContent = this.statusMessage(status, progress, total)
    this.renderErrors(status.errors)

    if (status.status === "completed") {
      this.stopPolling()
      this.submitTarget.disabled = false
      this.downloadLinkTarget.href = this.url(this.downloadUrlValue)
      this.downloadLinkTarget.download = status.filename || ""
      this.resultTarget.hidden = false
    }

    if (status.status === "failed" || status.status === "missing") {
      this.fail(this.statusMessage(status, progress, total))
    }
  }

  reset() {
    this.stopPolling()
    this.progressTarget.hidden = false
    this.resultTarget.hidden = true
    this.errorsTarget.hidden = true
    this.errorsTarget.innerHTML = ""
    this.messageTarget.textContent = "Avvio elaborazione"
    this.progressBarTarget.value = 0
  }

  fail(message) {
    this.stopPolling()
    this.submitTarget.disabled = false
    this.messageTarget.textContent = message
  }

  stopPolling() {
    if (this.pollTimer) {
      window.clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }

  url(template) {
    return template.replace("__JOB_ID__", this.jobId)
  }

  updateLocation() {
    const url = new URL(window.location.href)
    url.searchParams.set("job_id", this.jobId)
    window.history.replaceState({}, "", url.toString())
  }

  statusMessage(status, progress, total) {
    const succeeded = Number(status.succeeded || 0)
    const failed = Number(status.failed || 0)

    if (failed > 0 || status.status === "failed") {
      return `${this.countLabel(succeeded, "riuscito", "riusciti")}, ${this.countLabel(failed, "fallito", "falliti")}`
    }

    if (status.status === "completed" && succeeded > 0) {
      return `${this.countLabel(succeeded, "riuscito", "riusciti")}`
    }

    return `${status.message || status.status} (${progress}/${total})`
  }

  countLabel(count, singular, plural) {
    return `${count} ${count === 1 ? singular : plural}`
  }

  renderErrors(errors = []) {
    if (errors.length === 0) {
      this.errorsTarget.hidden = true
      this.errorsTarget.innerHTML = ""
      return
    }

    this.errorsTarget.hidden = false
    this.errorsTarget.innerHTML = `
      <details>
        <summary>Mostra dettagli (${errors.length})</summary>
        <ul>${errors.map(error => `<li>${this.escapeHtml(error)}</li>`).join("")}</ul>
      </details>
    `
  }

  escapeHtml(value) {
    const div = document.createElement("div")
    div.textContent = value
    return div.innerHTML
  }
}
